import React from "react";
import { useTranslation } from "react-i18next";

const ConsultantMenuCard = ({ menuItem }) => {
  const { t } = useTranslation();
  const IconComponent = menuItem.icon;

  // Derive hover colors based on the original icon color
  const getHoverColors = (iconForeground) => {
    if (iconForeground.includes('blue')) {
      return { 
        bg: 'group-hover:bg-blue-600', 
        text: 'group-hover:text-blue-600',
        button: {
          text: 'text-blue-600',
          bg: 'bg-blue-50',
          border: 'border-blue-200/60',
          hover: 'hover:bg-blue-600 hover:text-white hover:border-blue-600',
          focus: 'focus:ring-blue-500'
        }
      };
    } else if (iconForeground.includes('teal')) {
      return { 
        bg: 'group-hover:bg-teal-600', 
        text: 'group-hover:text-teal-600',
        button: {
          text: 'text-teal-600',
          bg: 'bg-teal-50',
          border: 'border-teal-200/60',
          hover: 'hover:bg-teal-600 hover:text-white hover:border-teal-600',
          focus: 'focus:ring-teal-500'
        }
      };
    } else if (iconForeground.includes('green')) {
      return { 
        bg: 'group-hover:bg-green-600', 
        text: 'group-hover:text-green-600',
        button: {
          text: 'text-green-600',
          bg: 'bg-green-50',
          border: 'border-green-200/60',
          hover: 'hover:bg-green-600 hover:text-white hover:border-green-600',
          focus: 'focus:ring-green-500'
        }
      };
    } else {
      // Default gray colors
      return { 
        bg: 'group-hover:bg-gray-600', 
        text: 'group-hover:text-gray-600',
        button: {
          text: 'text-gray-600',
          bg: 'bg-gray-50',
          border: 'border-gray-200/60',
          hover: 'hover:bg-gray-600 hover:text-white hover:border-gray-600',
          focus: 'focus:ring-gray-500'
        }
      };
    }
  };

  const hoverColors = getHoverColors(menuItem.iconForeground);

  return (
    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
      <div className="group bg-white border border-slate-200/60 rounded-xl p-6 hover:shadow-lg hover:shadow-slate-900/5 hover:border-slate-300/60 transition-all duration-200 ease-in-out hover:-translate-y-1 h-full flex flex-col">
        <div className="flex items-start space-x-4 flex-1">
          <div className="flex-shrink-0">
            <div className={`w-12 h-12 ${menuItem.iconBackground} rounded-lg flex items-center justify-center text-xl ${hoverColors.bg} transition-all duration-200`}>
              <IconComponent className={`w-6 h-6 ${menuItem.iconForeground} group-hover:text-white transition-colors duration-200`} />
            </div>
          </div>
          <div className="flex-1 min-w-0 flex flex-col h-full">
            <h3 className={`text-lg font-semibold text-slate-900 mb-2 ${hoverColors.text} transition-colors duration-200`}>
              {menuItem.title}
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed mb-4 flex-1">
              {menuItem.description}
            </p>
            <div className="mt-auto">
              <button
                onClick={menuItem.onClick}
                className={`inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 ${hoverColors.button.focus} focus:ring-offset-2 transition-all duration-200 ${hoverColors.button.text} ${hoverColors.button.bg} border ${hoverColors.button.border} ${hoverColors.button.hover}`}
              >
                {t("common.manage")}
                <svg 
                  className="ml-2 w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultantMenuCard;